import React from "react";

// Lib
import { Controller } from "react-hook-form";

// Components
import FieldText from "components/UiKit/FieldText";
import FieldRadio from "components/UiKit/FieldRadio";

// Constants
const optionsTypeStucture = [
  { value: "exact", label: "Exact" },
  { value: "substructure", label: "Substructure" },
  { value: "similarity", label: "Similarity" }
];

// Interface
interface IBar {
  errors?: any,
  control?: any,
  register?: any,
}

const Bar: React.FC<IBar> = (props) => {
  const { errors, control, register } = props;

  return (
    <div className="search-screen__structure-bar flex flex-ai-center" id="structure-search-type">
      <Controller
        control={control}
        name="typeStructure"
        rules={{ required: true }}
        render={({ field: { onChange, value } }) => {
          return (
            <FieldRadio
              className="mr20"
              onChange={onChange}
              name="typeStructure"
              options={optionsTypeStucture}
              isError={!!errors?.typeStructure}
              register={register("typeStructure", { required: true })}
              classNameWrapper="search-screen__structure-field-radio flex-wrap"
              msgError={errors?.typeStructure ? errors?.typeStructure?.message : ""}
            />
          );
        }}
      />

      <FieldText
        name="searchSimilarity"
        style={{ width: "5rem" }}
        isError={!!errors?.searchSimilarity}
        register={register("searchSimilarity")}
        msgError={errors?.searchSimilarity ? errors?.searchSimilarity.message : ""}
      />
    </div>
  );
};
export default Bar;

